// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trusted[data-v-6a722cae] {\n  color: #666260;\n}", ""]);
// Exports
module.exports = exports;
